import { useCallback, useEffect, useState } from 'react';
function useCheckScreenWidth(_a) {
    var minWidth = _a.minWidth;
    var _b = useState(false), isMobile = _b[0], setIsMobile = _b[1];
    var onResize = useCallback(function () {
        var body = document.body;
        var width = body.getBoundingClientRect().width;
        setIsMobile(width <= minWidth);
    }, [minWidth]);
    useEffect(function () {
        window.addEventListener('resize', onResize);
        onResize();
        return function () {
            window.removeEventListener('resize', onResize);
        };
    }, [onResize]);
    return isMobile;
}
export default useCheckScreenWidth;
//# sourceMappingURL=useCheckScreenWidth.js.map